import React, { Component } from 'react';
import { HashRouter as Router, Route } from "react-router-dom";
import RoundGames from './RoundGames';
import PlayerGames from './PlayerGames';
import SingleGameViewer from './SingleGameViewer';
import PositionIDViewer from './PositionIDViewer';
import SinglePairGames from './SinglePairGames';
import './App.css';
import './tools'
import FenViewer from './FenViewer';



class App extends Component {
  render() {
    return (
        <div>
            <Router>
                <Route path="/viewer/:tourn?/:round?/:rounds?/:onlyWithMoves?" component={RoundGames} />
            </Router>
            <Router>
                <Route path="/round/:tourn?/:round?/:rounds?/:onlyWithMoves?/:club?" component={RoundGames} />
            </Router>
            <Router>
                <Route path="/player/:tourn/:playerDapId" component={PlayerGames} />
            </Router>
            <Router>
                <Route path="/onegame/:tourn?/:gameId?" component={SingleGameViewer} />
            </Router>
            <Router>
                <Route path="/oneviewer/:tourn?/:gameId?" component={SingleGameViewer} />
            </Router>
            <Router>
                <Route path="/single_game/:tourn?/:gameId?" component={SingleGameViewer} />
            </Router>
            <Router>
                <Route path="/single_pair/:tourn?/:player1DapId?/:player2DapId?/:round?" component={SinglePairGames} />
            </Router>
            <Router>
                <Route path="/fen_viewer/:size?/:boardType?/:draughtsType?/:fen?" component={FenViewer} />
            </Router>
            <Router>
                <Route path="/position/:size?/:boardType?/:draughtsType?/:id?" component={PositionIDViewer} />
            </Router>
        </div>
    )
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js